import React,{useEffect,useState} from "react";
import Axios from "../../services/AxiosInstance";

const RequestTraining = () => {

const [data,setData]=useState([]);

const [openComment,setOpenComment]=useState(false);

const [selectedComment,setSelectedComment]=useState("");

const [openEdit,setOpenEdit]=useState(false);

const [editData,setEditData]=useState({});

const [searchBy,setSearchBy] =
useState("");

const [searchText,setSearchText] =
useState("");

const [filteredData,setFilteredData] =
useState([]);

const [currentPage,
setCurrentPage]
=
useState(1);

const rowsPerPage =
10;



// FETCH
const fetchData=async()=>{

try{

const res=
await Axios.get(
"/api/training/request-training"
);

if(res.data.success){

setData(
res.data.data
);

setFilteredData(
res.data.data
);

}

}

catch(err){

console.log(err);

}

};

const searchData =
()=>{

if(
!searchBy
||
!searchText
){

setFilteredData(
data
);

return;

}

const result =
data.filter(
(item)=>

String(

item[
searchBy
]

||
""

)

.toLowerCase()

.includes(

searchText
.toLowerCase()

)

);

setFilteredData(
result
);

};



const removeFilter =
()=>{

setSearchBy(
""
);

setSearchText(
""
);

setFilteredData(
data
);

};


// STATUS UPDATE
const updateStatus=
async(id,status)=>{

try{

await Axios.put(
"/api/training/update-status",
{
id,
status
}
);

setData(prev=>

prev.map(item=>

item.id===id
?

{
...item,
status
}

:

item

)

);

}

catch(err){

console.log(err);

}

};


// EDIT UPDATE
const updateTraining=
async()=>{

try{

const payload={

id:editData.id,

trainingName:
editData.trainingName,

category:
editData.category,

level:
editData.level,

comments:
editData.comments

};

console.log(
"UPDATE DATA",
payload
);

await Axios.put(
"/api/training/update",
payload
);

await fetchData();

setOpenEdit(false);

}

catch(err){

console.log(err);

}

};

// DELETE
const deleteTraining=
async(id)=>{

const ok=
window.confirm(
"Delete request?"
);

if(!ok)
return;

try{

await Axios.delete(
"/api/training/delete/"+id
);

await fetchData();

}

catch(err){

console.log(err);

}

};


// OPEN EDIT
const openEditModal=
(item)=>{

setEditData(item);

setOpenEdit(true);

};


const lastIndex =
currentPage
*
rowsPerPage;

const firstIndex =
lastIndex
-
rowsPerPage;


const currentData =

filteredData
?.slice(

firstIndex,

lastIndex

)

||
[];


const totalPages =

Math.ceil(

(

filteredData
?.length

||

0

)

/

rowsPerPage

);




useEffect(()=>{

fetchData();

},[]);


return(

<div style={{padding:"20px"}}>

<center>

<h2>
Request Training
</h2>

</center>


<div

style={{

display:"flex",

gap:"10px",

justifyContent:"center",

marginBottom:"20px",

flexWrap:"wrap"

}}

>

<select

className="form-control"

value={searchBy}

onChange={(e)=>
setSearchBy(
e.target.value
)
}

style={{

width:"220px",

height:"48px",

padding:"0 14px",

fontSize:"16px",

background:"#fff",

color:"#000",

border:"1px solid #ddd",

borderRadius:"8px",

appearance:"auto"

}}

>

<option value="">
Search By
</option>

<option value="business_name">
Busi Name
</option>

<option value="category">
Category
</option>

<option value="contactNumber">
Contact No.
</option>

<option value="level">
Level
</option>

</select>


<input

className="form-control"

style={{
width:"250px"
}}

placeholder="Search..."

value={searchText}

onChange={(e)=>

setSearchText(
e.target.value
)

}

/>


<button

className="btn btn-primary"

onClick={
searchData
}

>

Search

</button>


<button

className="btn btn-danger"

onClick={
removeFilter
}

>

Remove

</button>

</div>


<div
style={{
overflowX:"auto"
}}
>   

<table
className="table"
style={{
width:"100%",
borderCollapse:"collapse"
}}
>

<thead>

<tr>

<th>S.No.</th>

<th>Busi Name</th>

<th>Category</th>

<th>Comments</th>

<th>Contact No.</th>

<th>Created At</th>

<th>Level</th>

<th>Status</th>

<th>Training Name</th>

<th>Action</th>

</tr>

</thead>


<tbody>

{

currentData.map(
(item,index)=>

<tr
key={item.id}
>

<td>

{

firstIndex
+
index
+
1

}

</td>

<td>{item.business_name}</td>

<td>{item.category}</td>


<td>

<button

onClick={()=>{

setSelectedComment(
item.comments ||
"No comments available"
);

setOpenComment(
true
);

}}

style={{

background:"#0d6efd",

color:"#fff",

border:"none",

padding:"4px 10px",

borderRadius:"5px",

cursor:"pointer"

}}

>

View

</button>

</td>


<td>

{
item.contactNumber
}

</td>


<td>

{

item.createdAt?._seconds

?

new Date(

item.createdAt._seconds*1000

)

.toLocaleString()

:

"-"

}

</td>


<td>

{
item.level
}

</td>


<td>

<select

value={
item.status
}

onChange={(e)=>

updateStatus(

item.id,

e.target.value

)

}

style={{

padding:"6px",

border:"none",

borderRadius:"8px",

color:"#fff",

background:

item.status==="completed"

?

"#28a745"

:

item.status==="rejected"

?

"#dc3545"

:

"#ffc107"

}}

>

<option value="requested">
Requested
</option>

<option value="completed">
Completed
</option>

<option value="rejected">
Rejected
</option>

</select>

</td>


<td>

{
item.trainingName
}

</td>


<td>

<div
style={{
display:"flex",
gap:"8px",
alignItems:"center",
justifyContent:"center",
minWidth:"140px"
}}
>

<button
className="btn btn-primary btn-sm"
style={{
padding:"6px 14px",
borderRadius:"8px",
minWidth:"70px"
}}
onClick={()=>
openEditModal(item)
}
>

Edit

</button>


<button
className="btn btn-danger btn-sm"
style={{
padding:"6px 14px",
borderRadius:"8px",
minWidth:"70px"
}}
onClick={()=>
deleteTraining(item.id)
}
>

Delete

</button>

</div>

</td>
</tr>

)



}

</tbody>

</table>

</div>

<div

style={{

display:"flex",

justifyContent:
"center",

alignItems:
"center",

gap:"10px",

marginTop:"25px"

}}

>

<button

className="btn btn-secondary"

disabled={
currentPage===1
}

onClick={()=>

setCurrentPage(

currentPage
-
1

)

}

>

Prev

</button>


<span>

Page

{

currentPage

}

/

{

totalPages

||

1

}

</span>


<button

className="btn btn-primary"

disabled={

currentPage
===

totalPages

}

onClick={()=>

setCurrentPage(

currentPage
+
1

)

}

>

Next

</button>

</div>



{

openComment && (

<div

style={{

position:"fixed",

top:0,

left:0,

width:"100%",

height:"100%",

background:
"rgba(0,0,0,.4)",

display:"flex",

justifyContent:"center",

alignItems:"center"

}}

>

<div

style={{

background:"#fff",

padding:"20px",

width:"450px",

borderRadius:"10px"

}}

>

<div
style={{
display:"flex",
justifyContent:"space-between",
alignItems:"center",
marginBottom:"15px"
}}
>

<h4
style={{
margin:0
}}
>
Comments
</h4>

<button
onClick={()=>
setOpenComment(false)
}
style={{
border:"none",
background:"transparent",
fontSize:"28px",
cursor:"pointer",
fontWeight:"bold",
lineHeight:"1",
color:"#666"
}}
>

×

</button>

</div>


<p
style={{
lineHeight:"1.8"
}}
>

{selectedComment}

</p>
</div>

</div>

)

}



{

openEdit && (

<div

style={{

position:"fixed",

top:0,

left:0,

width:"100%",

height:"100%",

background:
"rgba(0,0,0,.45)",

display:"flex",

justifyContent:"center",

alignItems:"center"

}}

>

<div

style={{

background:"#fff",

padding:"20px",

width:"430px",

maxWidth:"75%",

borderRadius:"15px",

boxShadow:"0 8px 24px rgba(0,0,0,.15)"

}}

>

<h4>

Edit Request

</h4>


<label>

Training Name

</label>

<input

className="form-control"

value={
editData.trainingName||""
}

onChange={(e)=>

setEditData({

...editData,

trainingName:
e.target.value

})

}

/>

<br/>

<label>

Category

</label>

<select

className="form-control"

value={editData?.category || ""}

onChange={(e)=>

setEditData({

...editData,

category:e.target.value

})

}

style={{

height:"48px",
padding:"0 14px",
fontSize:"16px",
color:"#000",
background:"#fff"

}}

>

<option value="">
Select Category
</option>

<option value="Artificial Intelligence(AI)">
Artificial Intelligence(AI)
</option>

<option value="Full Stack Development">
Full Stack Development
</option>

<option value="Cloud">
Cloud
</option>

<option value="Digital Marketing">
Digital Marketing
</option>

</select>


<br/>


<label>

Level

</label>

<select

className="form-control"

value={editData?.level || ""}

onChange={(e)=>

setEditData({

...editData,

level:e.target.value

})

}

style={{

width:"100%",
height:"48px",
padding:"0 14px",
border:"1px solid #ddd",
borderRadius:"8px",
background:"#fff",
color:"#000",
fontSize:"16px"

}}

>

<option value="">
Select Level
</option>

<option value="Beginner">
Beginner
</option>

<option value="Intermediate">
Intermediate
</option>

<option value="Advanced">
Advanced
</option>

</select>
<br/>


<label>

Comments

</label>

<textarea

rows="3"

className="form-control"

value={
editData.comments||""
}

onChange={(e)=>

setEditData({

...editData,

comments:
e.target.value

})

}

/>


<div
style={{
marginTop:"20px"
}}
>

<button

className="btn btn-success"

onClick={
updateTraining
}

>

Save Changes

</button>


<button

className="btn btn-secondary"

style={{
marginLeft:"10px"
}}

onClick={()=>

setOpenEdit(
false
)

}

>

Cancel

</button>

</div>

</div>

</div>

)

}

</div>

);

};

export default RequestTraining;